import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { ISipCallSheet } from '@obvious.tech/constellation'

export const SipCallSheet = defineEntity('SipCallSheet', {
  endpoint: 'sip/api/SipCallSheet',
  schema: SNoop<ISipCallSheet>(),
})
